
import ShowMessage from './ShowMessage.jsx';
import Wrapper from '../../assets/wrappers/JobsContainer';
import { useAllMessagesContext } from '../../pages/ShowMessages.jsx';
import MessagePaginationContainer from './MessagePaginationContainer.jsx';

const ShowMessagesContainer = () => {
  const { data } = useAllMessagesContext();
  const { messages, totalMessages, numOfPages } = data;
  
  if (messages && messages.length === 0) {
    return (
      <Wrapper>
        <h5>לא נמצאו הודעות להציג...</h5>
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      <h5>נמצאו {totalMessages} הודעות</h5>
      <div className='jobs'>
        {messages && messages.map((message) => {
          return <ShowMessage key={message._id} {...message} />;
        })}
      </div>
      {numOfPages > 1 && <MessagePaginationContainer />}
    </Wrapper>
  );
};

export default ShowMessagesContainer;
